import { render, staticRenderFns } from "./cSwitchBar.vue?vue&type=template&id=cae4d670&scoped=true"
import script from "./cSwitchBar.vue?vue&type=script&lang=js"
export * from "./cSwitchBar.vue?vue&type=script&lang=js"
import style0 from "./cSwitchBar.vue?vue&type=style&index=0&id=cae4d670&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cae4d670",
  null
  
)

export default component.exports